/**
 * @author      Josh Cranwell <josh.cranwell@gmail.com>
 * @copyright   The Sweet People
 * @version     1.0
 * @link        https://www.thesweetpeople.com/
 * @since       20 March 2023
 */

// import debounce from lodash
import { debounce } from 'lodash';

// jQuery on ready
jQuery(function($) {

    /**
     * @param value
     */
    function format_money(value) {

        // round the value to two decimal places
        value = parseFloat(value.toFixed(2));

        // add a comma separator for the thousands place
        value = value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");

        // add a leading zero if necessary
        if (value.indexOf('.') === -1) {
            value += '.00';
        } else if (value.indexOf('.') === value.length - 2) {
            value += '0';
        }

        // return the value
        return value;

    }

    // all pricing blocks
    let product_pricing = $('.product-pricing-v2', document);

    // run pricing form events
    pricing_form_events(product_pricing);

    // winodw loaded
    $(window).on('load',function() {

        // detect when a new pricing form is added to the DOM
        $(document).on('DOMNodeInserted','#quicklook_modal_body',function(e) {

            // if the newly added element has the pri
            if($(e.target).hasClass('product-single')) {

                // get the newly added pricing form
                let product_pricing = $('.product-pricing-v2', e.target);

                // run pricing form events on newly added pricing form
                pricing_form_events(product_pricing);

            }

        });

    });

    /**
     * @param product_pricing
     */
    function pricing_form_events(product_pricing) {

        // pricing form object
        $(product_pricing)

            // pricing form country select on change
            .on('input','[name="shipping_country"]',function(e) {

                // load shipping servicess
                load_shipping_services(e.currentTarget);

                // get express origination checkbox
                express_origination_checkbox_visibility(e.currentTarget, product_pricing);

            })

            // pricing form service selcect on change
            .on('input', '[name="shipping_service"]', function (e) {

                // load pricing table
                load_pricing_table(e.currentTarget);

            })

            // pricing form origination input on change
            .on('input', '[name="express_origination"]', function (e) {

                // load pricing table
                load_pricing_table(e.currentTarget);

            })

            // pricing form currency select on change
            .on('input', '[name="pricing_currency"]', function (e) {

                // get selected currecy value
                let currency = e.currentTarget.value;

                // set currency cookie
                Cookies.set('pricing_currency', currency, {expires: 365});

                // load pricing table
                load_pricing_table(e.currentTarget);

            })

    }

    /**
     * @param target
     */
    function load_shipping_services(target) {

        // get selected country code
        let code = target.value;

        // get the current pricing form
        let product_pricing = $(target).closest('.product-pricing-v2');

        // disable all shipping services
        $('[name="shipping_service"]', product_pricing).prop('disabled',true);

        // ajax call
        $.ajax({
            cache: false,
            timeout: 30000,
            url: admin_ajax_url,
            type: 'GET',
            data: {
                action: 'load_shipping_services',
                country: code
            }
        }).done(function (data) {

            // update shipping services group
            $('[data-group="services"]', product_pricing).replaceWith(data);

        }).then(function () {

            // load pricing table
            load_pricing_table(product_pricing);

        });

    }

    /**
     * @param target
     */
    window.load_pricing_table = function(target) {

        // get the current pricing form
        let product_pricing = $(target).closest('.product-pricing-v2');

        // get our shipping form variable
        let data = {
            product_id: $(product_pricing).data('product-id'),
            company_id: $(product_pricing).data('company-id'),
            country: $('[name="shipping_country"]', product_pricing).val(),
            service: $('[name="shipping_service"]:checked', product_pricing).val(),
            express_origination: $('[name="express_origination"]', product_pricing).is(':checked'),
            currency: $('[name="pricing_currency"]', product_pricing).val(),
            markup_unit: $(product_pricing).data('markup-unit'),
            markup_shipping: $(product_pricing).data('markup-shipping'),
            markup_origination: $(product_pricing).data('markup-origination'),
        };

        // enable quote download button
        $('.download-product-quote-v2', product_pricing)
            .addClass('disabled')
            .attr('href','#');

        // fade out pricing table
        $('.pricing-table-v2', product_pricing).find('.table-responsive')
            .fadeTo(0,0.5);

        // ajax call
        $.ajax({
            cache: false,
            timeout: 30000,
            url: admin_ajax_url,
            type: 'GET',
            data: {
                action: 'load_pricing_table',
                product_id: data.product_id,
                company_id: data.company_id,
                country: data.country,
                service: data.service,
                express_origination: data.express_origination,
                currency: data.currency,
                markup_unit: data.markup_unit,
                markup_shipping: data.markup_shipping,
                markup_origination: data.markup_origination
            }
        }).done(function (response) {

            // render the pricing table html
            $('.pricing-table-v2', product_pricing).find('.table-responsive')
                .html(response.data)
                .fadeTo(0,1);

            // initialize the tooltips again
            $('[data-toggle="tooltip"]').tooltip({ boundary: 'window' });

            // // if success is true
            // if(response.success) {
            //
            //     // get the download quote button href params
            //     let params = $.param(data);
            //
            //     // enable quote download button and set the href
            //     $('.download-product-quote-v2', product_pricing)
            //         .attr('href','/generate/quote?' + params)
            //         .removeClass('disabled');
            //
            // }

        }).then(function (response) {

            // if success is true
            if(response.success) {

                // get the encrypted params from data attribute
                let params = $('.pricing-table-v2 TABLE', product_pricing).data('params');

                // if params is not false
                if(params) {

                    // enable quote download button and set the href
                    $('.download-product-quote-v2', product_pricing)
                        .attr('href','/generate/quote?params=' + params)
                        .removeClass('disabled');

                }

            }

        });

    }


    // get custom pricing calculator
    let calculator_pricing = $('.custom-pricing-calculator', document);

    // pricing form object
    $(calculator_pricing)

        // pricing form country select on change
        .on('input','[name="shipping_country"]',function(e) {

            // load shipping servicess
            load_calculator_shipping_services(e.currentTarget);

            // get express origination checkbox
            express_origination_checkbox_visibility(e.currentTarget, calculator_pricing);

        })

        // pricing calculator express origination input on change
        .on('input', '[name="express_origination"]', function (e) {

            // load calculator price breaks json
            load_calculator_json_price_breaks(calculator_pricing);

            // trigger calculator form submit
            //calculator_form_trigger_submit();

        })

        // pricing form currency select on change
        .on('input', '[name="pricing_currency"]', function (e) {

            // get selected currecy value
            let currency = e.currentTarget.value;

            // set currency cookie
            Cookies.set('pricing_currency', currency, {expires: 365});

            // input unit price
            let input_unit = $('[name="add_calculator_unit"]', calculator_pricing);

            // input unit origination
            let input_origination = $('[name="add_calculator_origination"]', calculator_pricing);

            // input unit price and origination
            input_unit.prop('checked',false);
            input_origination.prop('checked',false);

            // load calculator price breaks json
            load_calculator_json_price_breaks(calculator_pricing);

        })

        // calculator qty input on change
        .on('input', '[name="calculator_qty"]', debounce(function (e) {

            // lets get the min value
            let min = parseInt(e.currentTarget.min,10);

            // if current value is equal or greater than min
            if (e.currentTarget.value >= min) {

                // get the add unit price input
                let add_unit = $('[name="add_calculator_unit"]', calculator_pricing);

                // if add unit price is not checked
                if(!add_unit.prop('checked')) {

                    // get the current calculator pricing data
                    let data = JSON.parse($(calculator_pricing).attr('data-pricing'));

                    // check if json data has the price_breaks property
                    if (data.hasOwnProperty('price_breaks')) {

                        // set our quantity input and unit price input
                        let qty_input = e.currentTarget.value;
                        let unit_price_input = $('[name="calculator_unit"]', calculator_pricing);

                        // set the entered quantity and unit price
                        let entered_qty = parseInt(qty_input, 10);
                        let unit_price;

                        // if enter quanity is a number
                        if (!isNaN(entered_qty)) {

                            // set the unit_price to the lowest unit price initially
                            unit_price = data.price_breaks[0].unit_price;

                            // loop through the price_breaks array
                            for (let i = 0; i < data.price_breaks.length; i++) {

                                // check if the entered_qty is greater than or equal to the current price_break's quantity
                                if (entered_qty >= data.price_breaks[i].quantity) {

                                    // update the unit_price variable with the unit_price of the current price_break
                                    unit_price = data.price_breaks[i].unit_price;

                                } else {

                                    // else if the entered_qty is less than the current price_break's quantity,
                                    // stop looping and keep the last matched unit_price
                                    break;
                                }
                            }
                        }

                        // update the unit price input value
                        unit_price_input.val(unit_price ? unit_price.toFixed(2) : '');

                    }

                }

                // trigger calculator form submit
                calculator_form_trigger_submit();

            }

        },500))

        // check when the calculator qty input is blurred
        .on('blur', '[name="calculator_qty"]', function (e) {

            // lets get the min value
            let min = parseInt(e.currentTarget.min,10);

            // if current value is empty
            if(!e.currentTarget.value) {

                // reset the value to min
                $(e.currentTarget).val(e.currentTarget.min).trigger('input');

                // trigger calculator form submit
                calculator_form_trigger_submit();

            // if current value is less than min
            } else if (e.currentTarget.value < min) {

                // set the current value to the min
                $(e.currentTarget).val(e.currentTarget.min).trigger('input');

                // trigger calculator form submit
                calculator_form_trigger_submit();

            }

        })

        // add calculator unit price checkbox on change
        .on('input change', '[name="add_calculator_unit"]', function (e) {

            // get the calculator unit price input
            let input_unit = $('[name="calculator_unit"]', calculator_pricing);

            // if the custom add unit price is checked
            if(e.currentTarget.checked) {

                // disable the unit price input
                input_unit.prop('disabled',false);

            } else {

                // disable the unit price input
                input_unit.prop('disabled',true);

            }

        })

        // add calculator origination checkbox on change
        .on('input change', '[name="add_calculator_origination"]', function (e) {

            // get the calculator origination input
            let input_unit = $('[name="calculator_origination"]', calculator_pricing);

            // if the custom add origination is checked
            if(e.currentTarget.checked) {

                // disable the origination input
                input_unit.prop('disabled',false);

            } else {

                // disable the origination input
                input_unit.prop('disabled',true);

            }

        })

        // check when the calculator unit and origination input is blurred
        .on('input', '[name="calculator_unit"], [name="calculator_origination"]', debounce(function (e) {

            // if we have a current value
            if (e.currentTarget.value) {

                // lets get current target value
                let value = parseFloat(e.currentTarget.value);

                // format the value
                $(e.currentTarget).val(format_money(value));

                // trigger calculator form submit
                calculator_form_trigger_submit();

            }

        },750))

        // check when the calculator unit and origination input is blurred
        .on('change', '[name="shipping_service"]', function () {

            // trigger calculator form submit
            calculator_form_trigger_submit();

        });

    /**
     * @param target
     * @param elem
     */
    function express_origination_checkbox_visibility(target, elem) {

        // check if the selected country pricing is UK or EU
        $.ajax({
            cache: false,
            timeout: 30000,
            url: admin_ajax_url,
            type: 'GET',
            data: {
                action: 'check_shipping_country_pricing',
                shipping_country: target.value
            }
        }).done(function (response) {

            // if response data is uk or eu
            let pricing = response.data

            // get the express origination checkbox input
            let $input = $(elem).find('[name="express_origination"]');

            // if the pricing is uk
            if(pricing === 'uk') {

                // show the express origination checkbox
                $(elem).find('[name="express_origination"]').prop('disabled', false).parent().removeClass('d-none');

            // if the pricing  is eu
            } else if (pricing === 'eu') {

                // show the express origination checkbox
                $(elem).find('[name="express_origination"]').prop('disabled', true).parent().addClass('d-none');

            }

        });

    }

    /**
     * @param target
     */
    function load_calculator_shipping_services(target) {

        // get selected country code
        let code = target.value;

        // get the custom pricing calculator
        let calculator_pricing = $(target).closest('.custom-pricing-calculator');

        // disable all custom pricing calculator shipping services
        $('[name="shipping_service"]', calculator_pricing).prop('disabled',true);

        // ajax call
        $.ajax({
            cache: false,
            timeout: 30000,
            url: admin_ajax_url,
            type: 'GET',
            data: {
                action: 'load_shipping_services',
                country: code
            }
        }).done(function (data) {

            // update shipping services group
            $('[data-group="services"]', calculator_pricing).replaceWith(data);

        }).then(function () {

            // load calculor price breaks json
            load_calculator_json_price_breaks(calculator_pricing);

        });

    }

    /**
     * @param target
     */
    function load_calculator_json_price_breaks(target) {

        // get the custom pricing calculator
        let calculator_pricing = $(target);

        // set our data object
        let data = {
            product_id: $(calculator_pricing).data('product-id'),
            company_id: $(calculator_pricing).data('company-id'),
            country: $('[name="shipping_country"]', calculator_pricing).val(),
            currency: $('[name="pricing_currency"]', calculator_pricing).val(),
            express_origination: $('[name="express_origination"]', calculator_pricing).is(':checked'),
        };

        // get our add values
        let add = {
            unit_price: $('[name="add_calculator_unit"]', calculator_pricing).prop('checked'),
            origination: $('[name="add_calculator_origination"]', calculator_pricing).prop('checked'),
            shipping: $('[name="add_calculator_shipping"]', calculator_pricing).prop('checked')
        }

        // disable all calculator unit inputs
        $('[name="calculator_qty"], [name="calculator_unit"], [name="calculator_origination"], [type="submit"]', calculator_pricing).prop('disabled',true);

        // ajax call
        $.ajax({
            cache: false,
            timeout: 30000,
            url: admin_ajax_url,
            type: 'GET',
            data: {
                action: 'load_json_price_breaks',
                product_id: data.product_id,
                company_id: data.company_id,
                country: data.country,
                currency: data.currency,
                express_origination: data.express_origination
            }
        }).done(function (response) {

            // if success is true
            if(response.success) {

                // set data json with stringified response data
                let data_json = JSON.stringify(response.data);

                // add json to calculator data pricing
                $(calculator_pricing).attr('data-pricing', data_json);

                // update calculator unit price and origination currency symbol
                $('[name="calculator_unit"], [name="calculator_origination"]', calculator_pricing)
                    .closest('.input-group')
                    .find('.input-group-text')
                    .html(data.currency === 'eur' ? '€' : '£');

                // check if response.data has the price_breaks property
                if(response.data.hasOwnProperty('price_breaks')) {

                    // set price breaks
                    let price_breaks = response.data.price_breaks;

                    // is array of price breaks
                    if(Array.isArray(price_breaks) && price_breaks[0]) {

                        // set calculation unit to first price break unit
                        let first_price_break = price_breaks[0];

                        // if we have first priced break unit
                        if(first_price_break.unit_price) {

                            // set quantity input
                            let input_qty = $('[name="calculator_qty"]', calculator_pricing);

                            // set value on quantity input and enable
                            input_qty.val(first_price_break.quantity).prop('disabled',false);

                            // if the input qty min is undefined
                            if(!input_qty.attr('min')) {

                                // set the min value
                                input_qty.attr('min', first_price_break.quantity);

                            }

                            // set input unit price
                            let input_unit = $('[name="calculator_unit"]', calculator_pricing);

                            // enable all calculator unit inputs
                            input_unit.val(format_money(first_price_break.unit_price));

                            // if we have an add unit price
                            if(add.unit_price) {

                                // enable unit price input
                                input_unit.prop('disabled',false);

                            }

                        }

                    }

                }

                // check if response.data has the price_breaks property
                if (response.data.hasOwnProperty('origination')) {

                    // set origination
                    let origination = response.data.origination;

                    // if we have origination
                    if (origination !== null && origination !== undefined && origination !== '') {

                        // set input origination
                        let input_origination = $('[name="calculator_origination"]', calculator_pricing);

                        // set value on origination input and enable
                        input_origination.val(format_money(origination));

                        // if we have an add origination
                        if (add.origination) {

                            // enable origination input
                            input_origination.prop('disabled', false);

                        }
                    }
                }
            }

        }).then(function (response) {

            // if success is true
            if(response.success) {

                // enable the calculator submit button for calcaltion
                $('[type="submit"]', calculator_pricing).prop('disabled',false);

                // trigger calculator form submit
                calculator_form_trigger_submit();

            }

        });

    }

    // load calculator price breaks json
    load_calculator_json_price_breaks(calculator_pricing);

    // custom calculator form submit
    $('.custom-pricing-calculator-form', calculator_pricing).on('submit', function (e) {

        // prevent default
        e.preventDefault();

        // set our data object
        let data = {
            product_id: $(calculator_pricing).data('product-id'),
            company_id: $(calculator_pricing).data('company-id'),
            country: $('[name="shipping_country"]', calculator_pricing).val(),
            service: $('[name="shipping_service"]:checked', calculator_pricing).val(),
            express_origination: $('[name="express_origination"]', calculator_pricing).is(':checked'),
            currency: $('[name="pricing_currency"]', calculator_pricing).val(),
            custom_qty: $('[name="calculator_qty"]', calculator_pricing).val(),
            custom_unit: $('[name="calculator_unit"]', calculator_pricing).val(),
            custom_origination: $('[name="calculator_origination"]', calculator_pricing).val()
        }

        // remove the pricing calculation display nonw class
        $('.custom-pricing-calculation', calculator_pricing).removeClass('d-none');

        // enable quote download button
        $('.download-product-quote-v2', calculator_pricing)
            .addClass('disabled')
            .attr('href','#');

        // fade out pricing table
        $('.custom-pricing-calculation-table', calculator_pricing).find('.table-responsive')
            .fadeTo(0,0.5);

        // ajax call
        $.ajax({
            cache: false,
            timeout: 30000,
            url: admin_ajax_url,
            type: 'GET',
            data: {
                action: 'load_pricing_table',
                product_id: data.product_id,
                company_id: data.company_id,
                country: data.country,
                service: data.service,
                express_origination: data.express_origination,
                currency: data.currency,
                custom_qty: data.custom_qty,
                custom_unit: data.custom_unit,
                custom_origination: data.custom_origination
            }
        }).done(function (response) {

            // render the pricing table html
            $('.custom-pricing-calculation-table', calculator_pricing).find('.table-responsive')
                .html(response.data)
                .fadeTo(0,1);

            // initialize the tooltips again
            $('[data-toggle="tooltip"]').tooltip({ boundary: 'window' });

        }).then(function (response) {

            // // if success is true
            // if(response.success) {
            //
            //     // get the download quote button href params
            //     let params = $.param(data);
            //
            //     // enable quote download button and set the href
            //     $('.download-product-quote-v2', calculator_pricing)
            //         .attr('href', '/generate/quote?' + params)
            //         .removeClass('disabled');
            //
            // }

            // if success is true
            if(response.success) {

                // get the encrypted params from data attribute
                let params = $('.custom-pricing-calculation-table TABLE', calculator_pricing).data('params');

                // if params is not false
                if(params) {

                    // enable quote download button and set the href
                    $('.download-product-quote-v2', calculator_pricing)
                        .attr('href','/generate/quote?params=' + params)
                        .removeClass('disabled');

                }
            }

        });

    });

    // custom calculator form submit
    function calculator_form_trigger_submit() {

        // input unit price
        let input_unit = $('[name="calculator_unit"]', calculator_pricing);

        // input unit origination
        let input_origination = $('[name="calculator_origination"]', calculator_pricing);

        // if we have both input unit price and input origination
        if ((input_unit.val() && input_unit.val() !== '0.00') && input_origination.val()) {

            // trigger submit
            $('.custom-pricing-calculator-form', calculator_pricing).trigger('submit');

        }

    }

})